
export const name = "signup-ui-lego";
export const version = "1.22736";
